import { alertController } from '@ionic/vue';

export class AlertUtils {

    async presentAlert(message: any) {
        const alert = await alertController.create({
            message: message,
            header: 'SCMT Error',
            backdropDismiss: false,
            buttons:[{
                text: 'OK',
                role: 'cancel',
                handler: () => {
                    console.log('Cancel clicked');
                }
            }]
            // position: 'middle',
          });
          await alert.present();
        //   Comment for migration work
        // const alert = document.createElement('ion-alert');
        // alert.header = 'SCMT Error';
        // alert.message = message;
        // alert.backdropDismiss = false;
        // alert.buttons = [{
        //     text: 'OK',
        //     role: 'cancel',
        //     handler: () => {
        //         console.log('Cancel clicked');
        //     }
        // }];

        // document.body.appendChild(alert);
        // return alert.present();
    }

    async presentAlertMultipleButtons() {
        const alert = document.createElement('ion-alert');
        alert.header = 'Alert';
        alert.subHeader = 'Subtitle';
        alert.message = 'This is an alert message.';
        alert.buttons = ['Cancel', 'Open Modal', 'Delete'];

        document.body.appendChild(alert);
        return alert.present();
    }

    async presentAlertWithMsg(message: string) {
        const alert = document.createElement('ion-alert');
        alert.header = 'Alert';
        alert.subHeader = 'Subtitle';
        alert.message = message;
        alert.buttons = ['OK'];

        document.body.appendChild(alert);
        return alert.present();
    }
}